const BASE_URL = "https://dev.admin.myschoolling.com/v1/api"; //"http://127.0.0.1:8000/v1/api"// replace with your backend url

export const apiRequest = async (
  endpoint,
  method = "GET",
  body = null,
  token = null
) => {
  try {
    const isFormData = body instanceof FormData;

    const headers = {};

    // set JSON header if NOT FormData
    if (!isFormData) {
      headers["Content-Type"] = "application/json";
    }

    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    const response = await fetch(`${BASE_URL}/${endpoint}`, {
      method,
      headers,
      body: body
        ? isFormData
          ? body // send as-is
          : JSON.stringify(body) // JSON only
        : null,
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Something went wrong");
    }

    return data;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};